<template>
    <div>
        <form id="alvaraForm" class="ajax_off" @submit.prevent="validate">
            <div class="form-group">
                <cliente-select modal v-model.number="cliente_id" />
            </div>
            <div class="row">
                <div
                    :class="
                        `${
                            renovar_id
                                ? 'col-xl-6 col-lg-6'
                                : 'col-xl-3 col-lg-3'
                        } col-md-4 col-sm-6 col-12 p-3`
                    "
                    :style="
                        `${
                            alvara.tipo.color_id
                                ? 'background-color:' +
                                  alvara.tipo.color.bg_color +
                                  '; color:' +
                                  alvara.tipo.color.color
                                : ''
                        } `
                    "
                    v-for="(alvara, alvara_index) in alvaras"
                    :key="alvara_index"
                >
                    <div class="d-flex justify-content-between">
                        <label class="title"
                            >{{
                                alvara.tipo.short_name || alvara.tipo.tipo
                            }}:</label
                        >
                        <b-button
                            v-b-tooltip.hover.top
                            size="sm"
                            title="Não se aplica na atividade/Não monitorado pelo sistema"
                            variant="light"
                            @click.prevent="ocultar(alvara_index, alvara)"
                            ><i class="fas fa-eye-slash"></i
                        ></b-button>
                    </div>
                    <div class="form-group d-flex flex-column">
                        <label>Emissão alvará</label>
                        <date-picker
                            name="alvara_emissao"
                            placeholder="Selecione a data"
                            format="DD-MM-YYYY"
                            @input="checkDates(alvara_index)"
                            v-model="alvaras[alvara_index].alvara_emissao"
                            value-type="YYYY-MM-DD"
                        >
                        </date-picker>
                        <!-- <input
              type="date"
              v-model="alvaras[alvara_index].alvara_emissao"
              class="form-control alvara_input"
              placeholder="__/__/____"
            /> -->
                    </div>

                    <div class="form-group d-flex flex-column">
                        <label>Vencimento alvará</label>
                        <date-picker
                            name="alvara_vencimento"
                            placeholder="Selecione a data"
                            format="DD-MM-YYYY"
                            @input="checkDates(alvara_index)"
                            v-model="alvaras[alvara_index].alvara_vencimento"
                            value-type="YYYY-MM-DD"
                        ></date-picker>
                        <!-- <input
              type="date"
              v-model="alvaras[alvara_index].alvara_vencimento"
              class="form-control alvara_input"
              placeholder="__/__/____"
            /> -->
                    </div>

                    <strong
                        >Status
                        <small
                            >(Apenas quando não houver uma data acima)</small
                        ></strong
                    >

                    <div
                        class="form-check"
                        v-for="(status, status_index) in alvara_status"
                        :key="status_index"
                    >
                        <input
                            :id="alvara_index + ' ' + status_index"
                            type="radio"
                            class="form-check-input"
                            v-model="alvaras[alvara_index].status_id"
                            :value="status.id"
                            @change="
                                status.clear_date ? resetDate(alvara_index) : ''
                            "
                        />
                        <label
                            class="form-check-label"
                            :for="alvara_index + ' ' + status_index"
                        >
                            {{ status.nome }}
                        </label>
                    </div>
                </div>
                <div
                    :class="
                        `
           ${
               renovar_id ? 'col-xl-6 col-lg-6' : 'col-xl-3 col-lg-3'
           } col-md-4 col-sm-6 col-12
            d-flex
            align-item-center
            justify-content-center
          `
                    "
                    v-if="cliente_id && !renovar_id"
                >
                    <div class="card" style="width: 100%; min-height: 300px">
                        <a
                            href="#"
                            v-b-modal="'getOutrosAlvaras'"
                            class="
                card-body
                d-flex
                justify-content-center
                align-items-center
                flex-wrap
                add-custom-alvara
              "
                            v-b-tooltip.hover
                            title="Adicionar/cadastrar alvará"
                            style="color: gray"
                        >
                            <i class="fas fa-plus fa-w-14 fa-4x"></i>
                        </a>
                    </div>
                </div>
            </div>
        </form>

        <b-card>
            <b-card-text>
                <small>
                    <b>Legenda</b>
                    <p>
                        <i class="fa fa-info-circle"></i>
                        <strong>NA/NM:</strong> Não se aplica na atividade/Não
                        monitorado pelo sistema.
                    </p>
                    <p>
                        <i class="fa fa-info-circle"></i>
                        <strong>AGUARDANDO:</strong> Aguardando informações de
                        data de vencimento ou status do alvará.
                    </p>

                    <p>
                        <i class="fa fa-info-circle"></i>
                        <strong>DISPENSADO(CGSIM):</strong> Dispensado de
                        Licenciamento por força da Resolução CGSIM Nº 51, Lei nº
                        13.874, de 20 de setembro de 2019.
                    </p>

                    <p>
                        <i class="fa fa-info-circle"></i>
                        <strong>TERCEIROS:</strong> Alvará aos cuidados de
                        terceiros.
                    </p>
                </small>
            </b-card-text>
        </b-card>
        <modal size="md" id="getOutrosAlvaras">
            <AtivarAlvara
                :cliente_id="cliente_id"
                :alvaras="alvaras"
                @updateAlvaras="getAlvaras()"
            />
        </modal>
    </div>
</template>

<script>
import ClienteSelect from "../../sistema/ClientesSelect.vue";
import AtivarAlvara from "./AtivarAlvara.vue";

export default {
    components: { ClienteSelect, AtivarAlvara },
    props: {
        renovar_id: Number,
        cliente_selecionado: Number
    },
    data() {
        return {
            cliente_id: null,
            alvara_status: [],
            cliente: {},
            alvaras: []
        };
    },
    watch: {
        cliente_id: function(newValue, oldValue) {
            this.getAlvaras();
        }
    },
    created() {
        if (this.cliente_selecionado) {
            this.cliente_id = this.cliente_selecionado;
        }
        this.getStatus();
    },
    methods: {
        async getAlvaras() {
            const result = await this.$api.get(
                `alvaras/cliente/${this.cliente_id}`
            );
            this.cliente = result.data;

            if (this.renovar_id) {
                this.alvaras = result.data.alvaras.filter(
                    item => item.id == this.renovar_id
                );
            } else {
                this.alvaras = result.data.alvaras;
            }
        },
        async getStatus() {
            const result = await this.$api.get("alvaras/status", {
                params: { page: "alvaras" }
            });
            this.alvara_status = result.data.status;
        },
        async submit() {
            await this.$api.put(`alvaras/cliente/${this.cliente_id}`, {
                alvaras: this.alvaras,
                cliente: this.cliente
            });
            this.$bvModal.hide("alvaraEdit");
            this.$bvModal.hide("alvara");
            this.$emit("updated");
        },
        checkDates(alvara_index) {
            this.alvaras[alvara_index].status_id = false;

            if (
                this.alvaras[alvara_index].alvara_emissao &&
                this.alvaras[alvara_index].alvara_vencimento
            ) {
                const emissao = new Date(
                    this.alvaras[alvara_index].alvara_emissao
                );
                const vencimento = new Date(
                    this.alvaras[alvara_index].alvara_vencimento
                );

                if (vencimento <= emissao) {
                    this.alvaras[alvara_index].alvara_emissao = null;

                    this.$swal({
                        icon: "warning",
                        title: `A data de vencimento do alvará ${this.alvaras[alvara_index].tipo.short_name} deve ser maior que a data de emissão.`
                    });
                }
            }
        },
        ocultar(alvara_index, alvara) {
            this.$swal({
                title: `O alvará ${alvara.tipo.short_name} não será mais monitorado pelo sistema! Deseja continuar?`,
                showDenyButton: true,
                confirmButtonText: "Sim",
                denyButtonText: `Não`
            }).then(result => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    this.alvaras.splice(alvara_index, 1);

                    this.$api.put(`alvara/${alvara.id}`, {
                        status_id: 2
                    });
                }
            });
        },
        validate() {
            let validate = true;
            const self = this;

            this.alvaras.map(function(alvara) {
                if (alvara.alvara_emissao && !alvara.alvara_vencimento) {
                    self.$swal({
                        icon: "warning",
                        title: `A data de vencimento do alvará ${alvara.tipo.short_name} deve ser preenchida`
                    });

                    validate = false;
                }

                if (
                    !alvara.status_id &&
                    !alvara.alvara_emissao &&
                    !alvara.alvara_vencimento
                ) {
                    self.$swal({
                        icon: "warning",
                        title: `Preencha o vencimento ou escolha um status para o alvará ${alvara.tipo.short_name}.`
                    });

                    validate = false;
                }
            });
            if (validate) this.submit();
        },

        resetDate(alvara_index) {
            this.alvaras[alvara_index].alvara_emissao = null;
            this.alvaras[alvara_index].alvara_vencimento = null;
        }
    }
};
</script>
